import script from "./orderReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./orderReceipt.vue?vue&type=script&setup=true&lang=js"

import "./orderReceipt.vue?vue&type=style&index=0&id=09f14090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f14090"]])

export default __exports__